// routesPaths.ts (or wherever you keep your routes constants)

export const SHOP_PATHS = {
  EDIT: '/shops/:shopId/edit',
  ADD_ITEM: '/shops/:shopId/items/add',
  EDIT_ITEM: '/shops/:shopId/items/:id/edit',
  ITEMS: '/shops/:shopId/items',

  PURCHASE_INVOICES: '/shops/:shopId/purchase-invoices',
  PURCHASE_ENTRY: '/shops/:shopId/new-purchase',
  EDIT_PURCHASE_INVOICE: '/shops/:shopId/purchase-invoices/:invoiceId/edit',
  PURCHASE_INVOICE_DETAIL: '/shops/:shopId/purchase-invoices/:invoiceId',
  PURCHASE_ADJUSTMENT_ITEMS: '/shops/:shopId/purchase-invoices/adjustment-items',

  MEDICINE_SELL_DB_VIEW: '/shops/:shopId/dashboard',
  MEDICINE_SELL_ENTRY: '/shops/:shopId/new-sell',
  MEDICINE_SELL_INVOICES: '/shops/:shopId/sells',
  MEDICINE_SELL_INVOICES_EDIT: '/shops/:shopId/sells/:invoiceId/edit',
  MEDICINE_SELL_INVOICE_DETAIL: '/shops/:shopId/sells/:invoiceId',
  SELL_ADJUSTMENT_ITEMS: '/shops/:shopId/sells/adjustment-items',

  INVENTORIES: '/shops/:shopId/inventories',
  ADD_INVENTORY: '/shops/:shopId/add-new',
  EDIT_INVENTORY: '/shops/:shopId/item/:itemId/edit',

  ITEM_UNITS: '/shops/:shopId/item-units',
  ADD_UNIT: '/shops/:shopId/item-units/add',
  EDIT_UNIT: '/shops/:shopId/item-units/:id/edit',

  LEDGER_ENTRIES: '/shops/:shopId/ledger-entries',

  STOCK_MOVEMENTS: '/shops/:shopId/stock-movements',
  BUSINESS_SETTINGS: '/business-settings',
};

export const MANUFACTURER_PATHS = {
  BASE: '/manufacturers',
  ADD_MANUFACTURER: '/manufacturers/add',
  EDIT_MANUFACTURER: '/manufacturers/:id/edit',
};

export const USER_PATHS = {
  BASE: '/users',
  ADD_USER: '/users/add',
  EDIT_USER: '/users/:id/edit',
  CHANGE_PASSWORD: '/users/:id/change-password',
  PERMISSIONS: '/permissions',
};
